import ThemeVars from "configs/theme"
const { variables: theme } = ThemeVars

export default theme
